import React from 'react';
const RefreshSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={props.onClick}
    >
      <g id="Group 19815">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 4.64103C7.48803 4.64103 4.64103 7.48803 4.64103 11C4.64103 11.2699 4.65779 11.5355 4.69026 11.7959C4.74633 12.2456 4.42726 12.6556 3.97758 12.7116C3.52791 12.7677 3.11792 12.4486 3.06185 11.999C3.021 11.6714 3 11.338 3 11C3 6.58172 6.58172 3 11 3C12.7759 3 14.4168 3.57912 15.7438 4.5577V3.82051C15.7438 3.36736 16.1111 3 16.5643 3C17.0174 3 17.3848 3.36736 17.3848 3.82051V6.51276C17.3848 6.96591 17.0174 7.33326 16.5643 7.33327L13.872 7.33333C13.4188 7.33334 13.0515 6.966 13.0515 6.51284C13.0515 6.05968 13.4188 5.69232 13.872 5.69231L14.5037 5.69229C13.4988 5.02752 12.2947 4.64103 11 4.64103ZM18.0223 9.28837C18.472 9.23223 18.882 9.55125 18.9381 10.0009C18.979 10.3287 19 10.6621 19 11C19 15.4183 15.4183 19 11 19C9.30357 19 7.73008 18.4715 6.4359 17.571V18.1795C6.4359 18.6326 6.06854 19 5.61538 19C5.16223 19 4.79487 18.6326 4.79487 18.1795V15.4872C4.79487 15.034 5.16223 14.6667 5.61538 14.6667H8.30769C8.76085 14.6667 9.12821 15.034 9.12821 15.4872C9.12821 15.9403 8.76085 16.3077 8.30769 16.3077H7.49635C8.50117 16.9725 9.70521 17.359 11 17.359C14.512 17.359 17.359 14.512 17.359 11C17.359 10.73 17.3422 10.4645 17.3097 10.2042C17.2536 9.75455 17.5726 9.34451 18.0223 9.28837Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default RefreshSVG;
